// Publish: the formats, a preview before building, and the build.
export { PublishPage as component } from '../../views/PublishPage.tsx';
export const room = 'publish';
export const page = 'publish';
export const title = 'Publish';
export const help = 'compile';
